<div class="department-card">
  <div class="department-header">
    <div class="department-color" [style.backgroundColor]="department.color"></div>
    <div class="department-title">{{ department.name }}</div>
    <div class="department-actions">
      <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
        <i class="icon-more-vertical"></i>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onEdit()">
          <span>{{ 'request_v2.common.edit' | translate }}</span>
        </button>
        <button mat-menu-item (click)="onDelete()">
          <span>{{ 'request_v2.common.delete' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="department-content">
    <div class="section">
      <div class="section-label">{{ 'request_v2.department_card.description' | translate }}</div>
      <div class="description-text">{{ department.description }}</div>
    </div>

    <div class="section" *ngIf="department.managers && department.managers.length > 0">
      <div class="section-label">{{ 'request_v2.department_card.managers' | translate }}</div>
      <div class="managers-list">
        <div class="manager-item" *ngFor="let manager of department.managers">
          <div class="manager-avatar" *ngIf="manager.picture">
            <img [src]="manager.picture" alt="Manager avatar">
          </div>
          <div class="manager-avatar" *ngIf="!manager.picture">
            <div class="avatar-placeholder">{{ manager.firstName.charAt(0) }}{{ manager.lastName.charAt(0) }}</div>
          </div>
          <div class="manager-info">
            <div class="manager-name">{{ manager.firstName }} {{ manager.lastName }}</div>
            <div class="manager-email">{{ manager.email }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 